import Uiconstants from '../../lib/UIconstants';
import { BetAmountArea } from './BetAmountArea';
import BetAmountController from '../../controllers/BetAmountController';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { COMPONENTS } from '../../lib/constants';

export const BetAmount = {
	name: COMPONENTS.BET_AMOUNT,
	position: {
		x: 1410,
		y: 710 - 41
	},
	controllers: [
		{
			Controller: BetAmountController,
			name: 'BetAmountController',
			config: {
				name: COMPONENTS.BET_AMOUNT,
				item: COMPONENTS.BET_AMOUNT,
				bets: GameConfigs.config.bet_steps,
				currency: GameConfigs.config.currency,
				btns: [Uiconstants.BTN_MINUS, Uiconstants.BTN_PLUS]
			}
		}
	],

	components: [
		{
			name: 'holder',
			type: 'Sprite',
			components: [
				{
					name: Uiconstants.BTN_MINUS,
					type: 'ActionButton',
					position: { x: 247, y: 54 },
					bg: 'decrease_bet_icon',
					bet: true
				},
				{
					name: 'BET_AMOUNT',
					//position: { x: -7, y: -30 },
					position: { x: 0, y: 0 },
					type: 'VisualComponent',
					component: BetAmountArea
				},
				{
					name: Uiconstants.BTN_PLUS,
					type: 'ActionButton',
					position: { x: 321, y: 54 },
					bg: 'increase_bet_icon',
					bet: true
				}
			]
		}
	]
};
